<div class="modal-container" *ngIf="updateDetailShow">
  <div class="modal-header">
    <h2 class="modal-title">
      <span>{{globalConstants.UPDATE_DETAILS_UPDATE_DET_MODAL}}</span>
    </h2>
    <button type="button" class="close btn-close pull-right" (mousedown)="onClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body update-detail-modal">
    <div class="required-info"><span
        class="required-text">*</span>{{globalConstants.INDICATES_REQ_FIELD_UPDATE_DET_MODAL}}
    </div>
    <div class="mt-3" *ngIf="radioValue === 'personalInfo' && accessData?.data?.personFlag === 'false'">
      <label>Staff Name: {{accessData?.data?.personData?.firstName}}
        {{accessData?.data?.personData?.lastName}}</label>
    </div>
    <div class="mt-3" *ngIf="accessData?.data?.personFlag === 'true'">
      <label>Staff Name: {{accessData?.data?.personData?.firstName}}
        {{accessData?.data?.personData?.lastName}}</label>
    </div>
    <div class="radio-input-container">
      <div class="radio-input-wrapper">
        <label for="radioInputs"
          class="form-label form-label-custom">{{globalConstants.WHAT_U_WANT_TO_CHANGE_UPDATE_DET_MODAL}} <span
            class="required-text">*</span></label>
        <div class="radio-inputs" id="radioInputs">
          <div class="form-check form-check-inline" *ngIf="accessData?.data?.personFlag === 'false' && isUpdateFlag">
            <label class="radio-label-wrap">
              <input class="form-check-input" type="radio" (change)="onItemChange('personalInfo')"
                name="updateRadioOptions" id="personalInfoRadio" value="personalInfo" [disabled]="isEmployee"
                [(ngModel)]="updateRadioOption">
              <span class="form-check-text">{{globalConstants.PERSONAL_INFO_UPDATE_DET_MODAL}}</span>
            </label>
          </div>
          <div class="form-check form-check-inline"
            *ngIf="(!nonEmployeeFlag && staffData?.length > 0) || (accessData?.data?.personFlag === 'true' && (userRole?.includes(globalConstants?.ROLE_HR) || userRole?.includes(globalConstants?.ROLE_IT_ADMIN)))">
            <label class="radio-label-wrap">
              <input class="form-check-input" type="radio" (change)="onItemChange('jobInfo')" name="updateRadioOptions"
                id="jobInfoRadio" value="jobInfo" [(ngModel)]="updateRadioOption">
              <span class="form-check-text">{{globalConstants.JOB_INFO_UPDATE_DET_MODAL}}</span>
            </label>
          </div>
          <div class="form-check form-check-inline"
            *ngIf="isUpdateFlag && ((!nonEmployeeFlag && staffData?.length > 0) || (accessData?.data?.personFlag === 'true' && (userRole?.includes(globalConstants?.ROLE_HR) || userRole?.includes(globalConstants?.ROLE_IT_ADMIN))))">
            <label class="radio-label-wrap">
              <input class="form-check-input" type="radio" (change)="onItemChange('programInfo')"
                name="updateRadioOptions" id="programRadio" value="programInfo" [(ngModel)]="updateRadioOption">
              <span class="form-check-text">{{globalConstants.DEPARTMENT_UPDATE_DET_MODAL}}</span>
            </label>
          </div>
          <div class="form-check form-check-inline"
            *ngIf="isUpdateFlag && ((!nonEmployeeFlag && staffData?.length > 0) || (accessData?.data?.personFlag === 'true' && (userRole?.includes(globalConstants?.ROLE_HR)|| userRole?.includes(globalConstants?.ROLE_IT_ADMIN) )))">
            <label class="radio-label-wrap">
              <input class="form-check-input" type="radio" (change)="onItemChange('managerInfo')"
                name="updateRadioOptions" id="managerRadio" value="managerInfo" [(ngModel)]="updateRadioOption">
              <span class="form-check-text">{{globalConstants.MANAGER_UPDATE_DET_MODAL}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="radioValue !== 'personalInfo' && accessData?.data?.personFlag === 'false'">
      <div class="col-md-6 col-lg-3">
        <div class="form-input-wrap">
          <label class="form-label form-label-custom">{{globalConstants.STAFF_NAME}} <span
              class="required-text">*</span></label>
          <ng-select [items]="staffData" bindLabel="fullName" bindValue="personId" [(ngModel)]="staffName"
            placeholder="Select" (change)="getStaffDetails()">
            <ng-template ng-option-tmp let-item="item">
              <div title="{{item.fullName}}">{{item.fullName}}</div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>

    <div class="update-details-form-container">
      <!-- Personal Information Update detail form -->
      <div class="update-details-form-wrap" *ngIf="radioValue === 'personalInfo' && personalRadioStatus">
        <form [formGroup]="personalDataForm" autocomplete="one-time-code">
          <div class="update-details-form-type">
            <div class="row mb-2">
              <div class="col-md-6 col-lg-3 infoType">
                <div class="form-input-wrap">
                  <label for="" class="form-label form-label-custom">{{globalConstants.REQUEST_TYPE}} <span
                      class="required-text">*</span></label>
                  <ng-select [items]="personalDetails" bindLabel="name" bindValue="id"
                    formControlName="personalDetailType" name="selectedDetailType" placeholder="Select">
                    <ng-template ng-option-tmp let-item="item">
                      <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>

          <div class="row"
            *ngIf="radioValue === 'personalInfo' && personalRadioStatus && personalDataForm.value['personalDetailType'] === 1">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <label for="lName"
                  class="form-label form-label-custom">{{globalConstants.LAST_NAME_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="lastName" id="lName"
                  placeholder="Enter Last Name" (keyup)="formChangeValidation()" charsOnly appTrim
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3" *ngIf="!approvalFlag">
              <div class="form-input-wrap mb-0">
                <label for="" class="form-label form-label-custom">{{globalConstants.DOCUMENT_UPDATE_DET_MODAL}} <span
                    class="required-text">*</span></label>
                <label for="upload-doc-input" class="upload-doc-label">
                  <input type="file" (change)="showName($event)" class="form-control" id="upload-doc-input"
                    style="visibility: hidden;" accept="image/jpeg,image/jpg,image/png,application/pdf">
                  <div class="upload-doc-filename">{{docName}}</div>
                </label>
              </div>
            </div>
          </div>
          <!-- <hr class="horizontal-line" /> -->
          <div class="row"
            *ngIf="radioValue === 'personalInfo' && personalRadioStatus && personalDataForm.value['personalDetailType'] === 2">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for=""
                  class="form-label form-label-custom">{{globalConstants.PRIMARY_EMAIL_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="primaryEmail" id=""
                  placeholder="Enter Primary Email" (keyup)="formChangeValidation()" appTrim
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for=""
                  class="form-label form-label-custom">{{globalConstants.PRIMARY_PHONE_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="primaryPhone" id=""
                  placeholder="Enter Primary Phone" (keyup)="formChangeValidation()" [maxLength]="10" numbersOnly
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for=""
                  class="form-label form-label-custom">{{globalConstants.PRIMARY_ADDRESS_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="primaryAddress" id=""
                  placeholder="Enter Primary Address" (keyup)="formChangeValidation()" appTrim
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for=""
                  class="form-label form-label-custom">{{globalConstants.APARTMENT_SUIT_UPDATE_DET_MODAL}}</label>
                <input type="text" class="form-control form-control-custom" formControlName="apartment" id=""
                  placeholder="Enter Apartment/Suit" (keyup)="formChangeValidation()" appTrim
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for="" class="form-label form-label-custom">{{globalConstants.CITY_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="city" id=""
                  placeholder="Enter City" (keyup)="formChangeValidation()" appTrim autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for="" class="form-label form-label-custom">{{globalConstants.STATE_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <ng-select [items]="stateData" bindLabel="stateName" bindValue="stateId" formControlName="state"
                  name="state" placeholder="Select" (change)="formChangeValidation()">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.stateName}}">{{item.stateName}}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for="" class="form-label form-label-custom">{{globalConstants.ZIP_CODE_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <weaccess-postal-code-input formControlName="zipcode"
                  (validationStatus)="handleValidationStatus($event)"></weaccess-postal-code-input>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap">
                <label for="" class="form-label form-label-custom">{{globalConstants.COUNTRY_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" formControlName="country" id=""
                  placeholder="Enter Country">
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Job Information Update detail form -->
      <div class="update-details-form-wrap" *ngIf="radioValue === 'jobInfo' && getFieldDisplayStatus()">
        <form [formGroup]="jobDataForm" autocomplete="one-time-code">
          <div class="update-details-form-type">
            <div class="row mb-2">
              <div class="col-md-6 col-lg-3 infoType">
                <div class="form-input-wrap">
                  <label for="" class="form-label form-label-custom">{{globalConstants.REQUEST_TYPE}}<span
                      class="required-text">*</span></label>
                  <ng-select [items]="dateTypeData" bindLabel="name" bindValue="id" formControlName="dateType"
                    name="selectedDetailType" placeholder="Select" (change)="formChangeValidation();dateTypeChange()">
                    <ng-template ng-option-tmp let-item="item">
                      <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="jobDataForm.value['dateType']===1">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <label for="jobTitle"
                  class="form-label form-label-custom">{{globalConstants.JOB_TITLE_UPDATE_DET_MODAL}}
                  <span class="required-text">*</span></label>
                <input type="text" class="form-control form-control-custom" id="jobTitle" formControlName="jobTitle"
                  placeholder="Enter Job title" (keyup)="formChangeValidation();optionChangeEvent('JobTitle')" appTrim
                  autocomplete="one-time-code">
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="startJobDate"
                    class="form-label form-label-custom">{{globalConstants.START_DATE_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <input *ngIf='!isJobDataChange' type="text" class="form-control form-control-custom form-input"
                      value="{{ jobMinDate | date: 'MM/dd/yyyy'}}" disabled>
                    <span *ngIf='isJobDataChange'>
                      <input type="text" class="form-control form-control-custom" id="startJobDate"
                        #dpStartDate="bsDatepicker" bsDatepicker [bsConfig]="{ showWeekNumbers: false }"
                        placeholder="Select" placement="top" formControlName="startJobDate"
                        (onHidden)="formChangeValidation()" (change)="formChangeValidation()"
                        (keyup)="formChangeValidation()" [minDate]="minStartDate" autocomplete="one-time-code">
                      <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                        (click)="dpStartDate.toggle()" placement="top" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <hr class="horizontal-line" /> -->
          <div class="row">
            <div class="col-md-6 col-lg-3" *ngIf="jobDataForm.value['dateType']===2">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="revocationJobDate"
                    class="form-label form-label-custom">{{globalConstants.REVOCATION_DATE_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <input type="text" class="form-control form-control-custom" id="revocationJobDate"
                      #dpRevDate="bsDatepicker" bsDatepicker formControlName="revocationJobDate" placeholder="Select"
                      placement="top" (onHidden)="formChangeValidation()" (change)="formChangeValidation()"
                      [minDate]="minStartDate" [bsConfig]="{showWeekNumbers: false}" autocomplete="one-time-code">
                    <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                      (click)="dpRevDate.toggle()" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3" *ngIf="jobDataForm.value['dateType']===3">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="suspensionJobDate"
                    class="form-label form-label-custom">{{globalConstants.SUSPENSION_DATE_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <input type="text" class="form-control form-control-custom" id="suspensionJobDate"
                      #dpSusDate="bsDatepicker" bsDatepicker formControlName="suspensionJobDate" placeholder="Select"
                      placement="top" [bsConfig]="{ showWeekNumbers: false }" (onHidden)="formChangeValidation()"
                      (change)="formChangeValidation()" [minDate]="minStartDate" autocomplete="one-time-code">
                    <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                      (click)="dpSusDate.toggle()" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3" *ngIf="jobDataForm.value['dateType']===4">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="terminationJobDate"
                    class="form-label form-label-custom">{{globalConstants.TERMINATION_DATE_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <input type="text" class="form-control form-control-custom" id="terminationJobDate"
                      #dpTerDate="bsDatepicker" bsDatepicker formControlName="terminationJobDate" placeholder="Select"
                      placement="top" (onHidden)="formChangeValidation()" (change)="formChangeValidation()"
                      [bsConfig]="{ showWeekNumbers: false }" [minDate]="minStartDate" autocomplete="one-time-code">
                    <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                      (click)="dpTerDate.toggle()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Department Information Update detail form -->
      <div class="update-details-form-wrap" *ngIf="radioValue === 'programInfo' && getFieldDisplayStatus()">
        <form [formGroup]="programDataForm" autocomplete="one-time-code">
          <div class="row update-details-form-type">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <label for=""
                  class="form-label form-label-custom">{{globalConstants.DEPARTMENT_DATE_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <ng-select [items]="programData" bindLabel="programName" bindValue="programId" placeholder="Select"
                  formControlName="programName" (change)="formChangeValidation()"
                  (close)="optionChangeEvent('Program')">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.programName}}">{{item.programName}}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="startProgramDate"
                    class="form-label form-label-custom">{{globalConstants.START_DATE1_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <input *ngIf='!isProgramChange' type="text" class="form-control form-control-custom form-input"
                      value="{{ programMinDate | date: 'MM/dd/yyyy'}}" disabled>
                    <span *ngIf='isProgramChange'>
                      <input type="text" class="form-control form-control-custom" id="startProgramDate"
                        #dpDStartDate="bsDatepicker" bsDatepicker formControlName="startProgramDate"
                        placeholder="Select" placement="top" (onHidden)="formChangeValidation()"
                        (change)="formChangeValidation()" [bsConfig]="{ showWeekNumbers: false }"
                        [minDate]="minStartDate" autocomplete="one-time-code">
                      <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                        (click)='dpDStartDate.toggle()' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Manager Information Update detail form -->
      <div class="update-details-form-wrap" *ngIf="radioValue === 'managerInfo' && getFieldDisplayStatus()">
        <form [formGroup]="managerDataForm" autocomplete="one-time-code">

          <div class="row mb-3" *ngIf="currentManagerName">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <label
                  class="form-label form-label-custom">{{globalConstants.CURRENT_MANAGER_NAME_UPDATE_DET_MODAL}}</label>
                <div class="datepicker-input-wrap">
                  <label class="labelText">{{currentManagerName}}</label>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="startManagerDate"
                    class="form-label form-label-custom">{{globalConstants.START_DATE1_UPDATE_DET_MODAL}}</label>
                  <div class="datepicker-input-wrap">
                    <label class="labelText">{{ managerMinDate | date: 'MM/dd/yyyy'}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-3">
              <div class="form-input-wrap mb-0">
                <label class="form-label form-label-custom">{{globalConstants.MANAGER_NAME_UPDATE_DET_MODAL}}<span
                    class="required-text">*</span></label>
                <ng-select [items]="managerData" bindLabel="fullName" bindValue="personId" placeholder="Select"
                  formControlName="managerName" (change)="formChangeValidation()"
                  (close)="optionChangeEvent('Manager')">
                  <ng-template ng-option-tmp let-item="item">
                    <div title="{{item.fullName}}">{{item.fullName}}</div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="col-md-6 col-lg-3" *ngIf='isManagerChange'>
              <div class="form-input-wrap mb-0">
                <div class="form-input-wrap mb-0">
                  <label for="startManagerDate"
                    class="form-label form-label-custom">{{globalConstants.START_DATE1_UPDATE_DET_MODAL}}<span
                      class="required-text">*</span></label>
                  <div class="datepicker-input-wrap">
                    <!-- <input *ngIf='!isManagerChange' type="text" class="form-control form-control-custom form-input"
                      value="{{ managerMinDate | date: 'MM/dd/yyyy'}}" disabled> -->
                    <span *ngIf='isManagerChange'>
                      <input type="text" class="form-control form-control-custom" id="startManagerDate"
                        #dpMIDStartDate="bsDatepicker" bsDatepicker placeholder="Select" placement="top"
                        formControlName="startManagerDate" (onHidden)="formChangeValidation()"
                        [bsConfig]="{ showWeekNumbers: false }" (change)="formChangeValidation()"
                        [minDate]="minStartDate" autocomplete="one-time-code">
                      <img src="../../../../assets/img/icons/calendar.svg" class="img-fluid calender-icon"
                        (click)='dpMIDStartDate.toggle()' />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
  <div class="modal-footer d-flex justify-content-end">
    <button type="submit" class="btn btn-outline"
      (click)="clearForm()">{{globalConstants.CLEAR_UPDATE_DET_MODAL}}</button>
    <!-- <button type="button" class="btn btn-orange w-18" *ngIf="radioValue === ('personalInfo' || undefined) else elseTemplate" (mousedown)="onClose()">Update</button> -->
    <button type="button" class="btn btn-orange" *ngIf="radioValue === ('personalInfo' || undefined) else elseTemplate"
      (click)="sendApprovalRequest(radioValue)"
      [disabled]="getBtnEnableStatus()">{{globalConstants.UPDATE_UPDATE_DET_MODAL}}</button>
    <ng-template #elseTemplate>
      <button type="button" class="btn btn-orange" (mousedown)="openConfirmModal(radioValue)"
        [disabled]="approvalFlag">{{globalConstants.SEND_FOR_APPROVAL_UPDATE_DET_MODAL}}</button>
    </ng-template>
  </div>
</div>